import * as React from 'react';
import './Spinner.css';
import withStyles, { StyledComponentProps } from 'react-jss'

const styles = {
    spin: {
        width: 40,
        height: 40,
        position: 'absolute',
        left: '50%',
        top: '50%',
        zIndex: 100,
        borderTop: '1px solid rgba(237,237,237,.8)',
        borderRight: '1px solid rgba(237,237,237,.8)',
        borderBottom: '1px solid rgba(237,237,237,.8)',
        borderLeft: '1px solid #000',
        borderRadius: '50%',
        transform: 'translate3d(-50%, -50%, 0)',
        animation: 'loadme-circular-animate 1.1s infinite linear',
    }
}

export type SpinnerProps = StyledComponentProps<keyof typeof styles> & { modifier?: string };
const Spinner: React.SFC<SpinnerProps> = (props) => {
    return (
        <div className="spin" />
    );
};

export default withStyles(styles)(Spinner);


// WEBPACK FOOTER //
// ./src/Components/Spinner/Spinner.tsx